import React, { useMemo } from 'react';
import Navbar from '../sections/Navbar';
import Footer from '../sections/Footer';
import StoreHero from '../sections/StoreHero';
import ProductCarousel from '../sections/ProductCarousel';
import CtaSection from '../sections/CtaSection';

// --- 1. IMPORT the static JSON data directly ---
import productData from '../data/products.json';

const StoreScreen = () => {
  // --- 2. GET the product list directly from the import ---
  const allProducts = useMemo(() => productData.products || [], []);

  // --- REMOVED: `isLoading` state and the data-fetching `useEffect` ---

  // --- This logic now works perfectly with the static data ---
  const availableProducts = allProducts.filter(product => product.availability === true);

  const categories = ['Best Sellers', 'Grams Pots', 'Grams Tools', 'Grams Coffee'];

  // --- REMOVED: The `isLoading` conditional return is no longer needed ---

  return (
    <>
      <Navbar />
      <main className="store-page-content">
        <StoreHero />
        
        {/* The mapping logic remains the same and works with the static data */}
        {categories.map(category => {
          const categoryProducts = availableProducts.filter(p => p.category === category);
          
          // Only render the carousel if there are products in that category
          if (categoryProducts.length > 0) {
            return (
              <ProductCarousel 
                key={category}
                title={category}
                products={categoryProducts}
              />
            );
          }
          return null; // Return null if the category is empty
        })}
      </main>
      <CtaSection />
      <Footer />
    </>
  );
};

export default StoreScreen;